import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ProductFamilyService } from '../../services/product-family/product-family.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductFamilyResolve implements Resolve<any> {

    constructor(private pfs: ProductFamilyService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.pfs.getProductFamilies().pipe(map(families => families)).pipe(first());
    }
}
